/* eslint func-style: "off" */
import orderBy from 'lodash/orderBy';
import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import {
  // Actions
  FETCH_ZCC_INSTALLATIONS,
  // loadProps,
  fetchZccInstallationsSucceeded,
  fetchZccInstallationsFailed,

} from './ZccInstallations.ducks';

import apiClient from 'helpers/apiClient';

// const getZccInstallations = (state) => state.ZccInstallations.zccInstallations;
const getSortingAttribute = (state) => state.ZccInstallations.sortingAttribute;
const getIsAscendingSort = (state) => state.ZccInstallations.isAscendingSort;

export const fetchZccInstallations = function* () {
  try {
    const sortingAttribute = yield select(getSortingAttribute);
    const isAscendingSort = yield select(getIsAscendingSort);
    const path = '/api/command-centers';
    const { installations: zccInstallations } = yield call(apiClient, path);
    const newZccInstallations = zccInstallations.map((zcc) =>
      ({
        account: zcc.account.name,
        name: zcc.name,
        id: zcc._id,
        version: zcc.version ? zcc.version.releaseName : 'unknown',
        lastPing: zcc.version ? zcc.version.updatedAt : undefined
      })
    );
    const direction = isAscendingSort ? 'asc' : 'desc';
    const sortedZccInstallations = orderBy(
      newZccInstallations,
      [(zcc) => zcc[sortingAttribute] && zcc[sortingAttribute].toLowerCase()],
      [direction]
    );
    yield put(fetchZccInstallationsSucceeded({
      zccInstallations: sortedZccInstallations
    }));
  } catch (e) {
    yield put(fetchZccInstallationsFailed(e));
  }
};

export const fetchZccInstallationsSaga = function* () {
  yield takeLatest(FETCH_ZCC_INSTALLATIONS, fetchZccInstallations);
};

const sagas = function* () {
  yield all([
    fork(fetchZccInstallationsSaga)
  ]);
};

export default sagas;
export {
  // selectors
  getSortingAttribute,
  getIsAscendingSort
};
